module.exports = __webpack_public_path__ + "static/media/power-all3.41f5fcb8.png";